import * as React from "react";
const SvgFiRrSofaSize = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sofa-size_svg__a)">
      <path
        fill="#062147"
        d="M21 13c-.352 0-.686.072-1 .184V12c0-2.206-1.794-4-4-4H8c-2.206 0-4 1.794-4 4v1.184A3 3 0 0 0 3 13c-1.654 0-3 1.345-3 3v1.5c0 1.556.795 2.93 2 3.738V23a1 1 0 0 0 2 0v-1.052c.166.02.329.052.5.052h15c.171 0 .334-.032.5-.052V23a1 1 0 0 0 2 0v-1.762a4.5 4.5 0 0 0 2-3.738V16c0-1.655-1.346-3-3-3M6 12c0-1.104.897-2 2-2h8c1.103 0 2 .896 2 2v4H6zm16 5.5c0 1.378-1.122 2.5-2.5 2.5h-15A2.503 2.503 0 0 1 2 17.5V16c0-.552.449-1 1-1s1 .448 1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1c0-.552.449-1 1-1s1 .448 1 1zM.522 5.253C.214 4.983 0 4.503 0 4s.214-.983.588-1.318L2.766.32a1 1 0 0 1 1.468 1.358l-1.222 1.32h17.979l-1.225-1.32A1 1 0 1 1 21.234.32l2.244 2.426c.308.27.522.75.522 1.253s-.214.983-.588 1.318l-2.178 2.36a.997.997 0 0 1-1.413.056 1 1 0 0 1-.055-1.413L20.988 5H3.009l1.225 1.32A1 1 0 1 1 2.766 7.68z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sofa-size_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSofaSize;
